import _sfc_main from "./Textarea.vue2.js";
/* empty css              */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const Textarea = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-e889f2d5"]]);
export {
  Textarea as default
};
//# sourceMappingURL=Textarea.vue.js.map
